import request from '@/utils/request'
const baseUrl = '/group'


/**
 * 我加入的小组
 */
export function getJoinedList(data = {}) {
  return request({
    url: `${baseUrl}/private/rest/group/list/joined`,
    method: 'POST',
    data: data.pageIndex ? data : {
      pageIndex: 1,
      pageSize: 100,
      sort: 'time',
    }
  })
}

/**
 * 我创建的小组
 */
export function getCreatedList(data = {}) {
  return request({
    url: `${baseUrl}/private/rest/group/list/created`,
    method: 'POST',
    data: data.pageIndex ? data : {
      pageIndex: 1,
      pageSize: 100,
      sort: 'time',
    }
  })
}

/**
 * 我管理的小组
 */
export function getManageList(data = {}) {
  return request({
    url: `${baseUrl}/private/rest/group/list/manage`,
    method: 'POST',
    data: data.pageIndex ? data : {
      pageIndex: 1,
      pageSize: 100,
      sort: 'time',
    }
  })
}

/**
 * 添加素材到小组中
 */
export function addMaterialToManyGroup(data) {
  return request({
    url: `${baseUrl}/private/rest/addMaterialToManyGroup`,
    method: 'POST',
    data
  })
}

/**
 * 添加学院教程到小组中
 */
export function addCourseToGroup(data) {
  return request({
    url: `${baseUrl}/private/rest/addCourseToGroup`,
    method: 'POST',
    data
  })
}

/**
 * 添加作品到小组
 */
export function addWorksToGroup(data) {
  return request({
    url: `${baseUrl}/private/rest/group/works/add`,
    method: 'POST',
    data
  })
}

/**
 * 添加素材到小组中
 */
export function addMaterialCreation(data) {
  return request({
    url: `${baseUrl}/private/rest/addMaterialCreation`,
    method: 'POST',
    data
  })
}